import React from 'react';
import { Box, Alert, Typography, Paper } from '@mui/material';

/**
 * 输出面板组件
 * 显示代码执行的输出结果
 */
function OutputPanel({ executeResult }) {
  if (!executeResult) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h6" color="text.disabled" gutterBottom>
          No output yet
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Click "Run" to execute your code and see the output here
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, height: '100%', overflow: 'auto' }}>
      <Alert
        severity={executeResult.status === 'success' ? 'success' : 'error'}
        sx={{ mb: 2 }}
      >
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          {executeResult.status === 'success' ? '✅ Code Executed Successfully' : '❌ Execution Error'}
        </Typography>
      </Alert>

      {executeResult.output && (
        <Box>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Output:
          </Typography>
          <Paper
            sx={{
              p: 2,
              bgcolor: 'grey.900',
              color: 'grey.100',
              fontFamily: 'monospace',
              fontSize: '12px',
              overflow: 'auto',
              maxHeight: 400
            }}
          >
            <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>
              {executeResult.output}
            </pre>
          </Paper>
        </Box>
      )}

      {executeResult.errorMessage && (
        <Alert severity="error" sx={{ mt: 2 }}>
          <Typography variant="body2">
            {executeResult.errorMessage}
          </Typography>
        </Alert>
      )}
    </Box>
  );
}

export default OutputPanel;

